import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import './settings.css'
import AdminManagement from './adminManagement'
import ChangePassword from './changePassword'
import MerchantProfile from './merchantProfile'
import { useSelector } from 'react-redux'
import MasterManagment from './master'
import RouteMap from './routeMap'
import SocialMedia from './socialMedia'
import { Grid } from '@mui/material'
import FAQ from './faq';
import AppContent from './appContent';

import RewardManagement from './rewardManagement';
import TermAndCondition from './termAndCondition';
import PrivacyPolicy from './privacyPolicy';
import LicenseAgreement from './licenseAgreement';

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            className={'tabpanel'}
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
}

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    }
}

const Settings = () => {
    const [value, setValue] = React.useState(0)
    const user = useSelector(state => state.user);

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    return (
        <div style={{ padding: '20px' }}>
            <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Tabs
                            orientation="vertical"
                            //   variant="scrollable"
                            value={value}
                            onChange={handleChange}
                            aria-label="Vertical tabs example"
                            sx={{ borderRight: 2, borderColor: 'divider' }}
                        >
                            {user && user.data.roles === "super_admin" &&
                                <Tab
                                    style={{ paddingLeft: '10px' }}
                                    icon={<img src={require('../../assets/images/Discount.png')} />}
                                    iconPosition="start"
                                    label={
                                        <div>
                                            <p className="tabSidebarLevel1">Admin Management</p>
                                            <p className="tabssubheading">Manage & add  admins</p>
                                        </div>
                                    }
                                    {...a11yProps(2)}
                                />
                            }
                            <Tab
                                style={{ paddingLeft: '5px' }}
                                icon={<img src={require('../../assets/images/unlock.png')} />}
                                iconPosition="start"
                                label={
                                    <div>
                                        <p className="tabSidebarLevel1">Security/Password</p>
                                        <p className="tabssubheading">Configure Password</p>
                                    </div>
                                }
                                {...a11yProps(3)}
                            />
                            {user && user.data.roles === "merchant" &&
                                <Tab
                                    disabled={user.data.last_login_at == 0}
                                    style={{ paddingLeft: '10px' }}
                                    icon={<img src={require('../../assets/images/Discount.png')} />}
                                    iconPosition="start"
                                    label={
                                        <div>
                                            <p className="tabSidebarLevel1">Edit Profile</p>
                                            <p className="tabssubheading">Manage & Edit Profile</p>
                                        </div>
                                    }
                                    {...a11yProps(2)}
                                />
                            }
                            {user && user.data.roles === "super_admin" &&
                                <Tab
                                    style={{ paddingLeft: '10px' }}
                                    icon={<img src={require('../../assets/images/About Us.png')} />}
                                    iconPosition="start"
                                    label={
                                        <div>
                                            <p className="tabSidebarLevel1">Master Management</p>
                                            <p className="tabssubheading">Groups,vehicles etc... </p>
                                        </div>
                                    }
                                    {...a11yProps(2)}
                                />
                            }
                            {user && user.data.roles === "super_admin" &&
                                <Tab
                                    style={{ paddingLeft: '0px' }}
                                    icon={<img src={require('../../assets/images/Component1.png')} />}
                                    iconPosition="start"
                                    label={
                                        <div>
                                            <p className="tabSidebarLevel1">Route Map</p>
                                            <p className="tabssubheading">Update route pdf files</p>
                                        </div>
                                    }
                                    {...a11yProps(2)}
                                />
                            }
                            {user && user.data.roles === "super_admin" &&
                                <Tab
                                    style={{ paddingLeft: '0px' }}
                                    icon={<img src={require('../../assets/images/emailphone (1).png')} />}
                                    iconPosition="start"
                                    label={
                                        <div>
                                            <p className="tabSidebarLevel1">Social Media</p>
                                            <p className="tabssubheading">Facebook , linkedin...</p>
                                        </div>
                                    }
                                    {...a11yProps(2)}
                                />
                            }
                            {user && user.data.roles === "super_admin" &&
                                <Tab
                                    style={{ paddingLeft: '0px' }}
                                    icon={<img width={28} height={28} src={require('../../assets/images/question-circle-svgrepo-com (1).svg').default} />}
                                    iconPosition="start"
                                    label={
                                        <div>
                                            <p className="tabSidebarLevel1">FAQ's</p>
                                            <p className="tabssubheading">Add , Edit and Delete</p>
                                        </div>
                                    }
                                    {...a11yProps(2)}
                                />
                            }
                            {user && user.data.roles === "super_admin" &&
                                <Tab
                                    style={{ paddingLeft: '0px', position: 'relative', left: '-6px' }}
                                    icon={<img width={20} height={20} src={require('../../assets/images/content-svgrepo-com (1).svg').default} />}
                                    iconPosition="start"
                                    label={
                                        <div>
                                            <p className="tabSidebarLevel1">App Content</p>
                                            <p className="tabssubheading">Update the content</p>
                                        </div>
                                    }
                                    {...a11yProps(2)}
                                />
                            }

                            {user && user.data.roles === "super_admin" &&
                                <Tab
                                    style={{ paddingLeft: '20px' }}
                                    icon={<img src={require('../../assets/images/Discount.png')} />}
                                    iconPosition="start"
                                    label={
                                        <div>
                                            <p className="tabSidebarLevel1">Reward Management</p>
                                            <p className="tabssubheading">Enable & Manage Rewards</p>
                                        </div>
                                    }
                                    {...a11yProps(2)}
                                />
                            }
                            {user && user.data.roles === "super_admin" &&
                                <Tab
                                    style={{ paddingLeft: '10px' }}
                                    icon={<img src={require('../../assets/images/Discount.png')} />}
                                    iconPosition="start"
                                    label={
                                        <div>
                                            <p className="tabSidebarLevel1">Term & Condition</p>
                                            <p className="tabssubheading">Manage Term & Condition</p>
                                        </div>
                                    }
                                    {...a11yProps(2)}
                                />
                            }
                            {user && user.data.roles === "super_admin" &&
                                <Tab
                                    style={{ paddingLeft: '10px', position: 'relative', left: '-9px' }}
                                    icon={<img src={require('../../assets/images/Discount.png')} />}
                                    iconPosition="start"
                                    label={
                                        <div>
                                            <p className="tabSidebarLevel1">Privacy Policy</p>
                                            <p className="tabssubheading">Manage Privacy Policy</p>
                                        </div>
                                    }
                                    {...a11yProps(2)}
                                />
                            }
                            {user && user.data.roles === "super_admin" &&
                                <Tab
                                    style={{ paddingLeft: '10px', position: 'relative', left: '6px' }}
                                    icon={<img src={require('../../assets/images/Discount.png')} />}
                                    iconPosition="start"
                                    label={
                                        <div>
                                            <p className="tabSidebarLevel1">License Agreement</p>
                                            <p className="tabssubheading">Manage License Agreement</p>
                                        </div>
                                    }
                                    {...a11yProps(2)}
                                />
                            }

                        </Tabs>
                    </Grid>
                    <Grid item xs={12} sm={6} md={9}>
                        {user && user.data.roles === "super_admin" &&
                            <TabPanel value={value} index={user && user.data.roles === "super_admin" ? 0 : null}>
                                <AdminManagement />
                            </TabPanel>
                        }

                        <TabPanel value={value} index={user && user.data.roles === "super_admin" ? 1 : 0}>
                            <ChangePassword />
                        </TabPanel>

                        {user && user.data.roles === "merchant" &&
                            <TabPanel value={value} index={user && user.data.roles === "merchant" ? 1 : null}>
                                <MerchantProfile />
                            </TabPanel>
                        }

                        {user && user.data.roles === "super_admin" &&
                            <TabPanel value={value} index={user && user.data.roles === "super_admin" ? 2 : null}>
                                <MasterManagment />
                            </TabPanel>
                        }
                        {user && user.data.roles === "super_admin" &&
                            <TabPanel value={value} index={user && user.data.roles === "super_admin" ? 3 : null}>
                                <RouteMap />
                            </TabPanel>
                        }
                        {user && user.data.roles === "super_admin" &&
                            <TabPanel value={value} index={user && user.data.roles === "super_admin" ? 4 : null}>
                                <SocialMedia />
                            </TabPanel>
                        }
                        {user && user.data.roles === "super_admin" &&
                            <TabPanel value={value} index={user && user.data.roles === "super_admin" ? 5 : null}>
                                <FAQ />
                            </TabPanel>
                        }
                        {user && user.data.roles === "super_admin" &&
                            <TabPanel value={value} index={user && user.data.roles === "super_admin" ? 6 : null}>
                                <AppContent />
                            </TabPanel>
                        }
                        {user && user.data.roles === "super_admin" &&
                            <TabPanel value={value} index={user && user.data.roles === "super_admin" ? 7 : null}>
                                <RewardManagement />
                            </TabPanel>
                        }
                        {user && user.data.roles === "super_admin" &&
                            <TabPanel value={value} index={user && user.data.roles === "super_admin" ? 8 : null}>
                                <TermAndCondition />
                            </TabPanel>
                        }
                        {user && user.data.roles === "super_admin" &&
                            <TabPanel value={value} index={user && user.data.roles === "super_admin" ? 9 : null}>
                                <PrivacyPolicy />
                            </TabPanel>
                        }
                        {user && user.data.roles === "super_admin" &&
                            <TabPanel value={value} index={user && user.data.roles === "super_admin" ? 10 : null}>
                                <LicenseAgreement />
                            </TabPanel>
                        }
                    </Grid>
                </Grid>

            </Box>
        </div>
    )
}

export default Settings


{/* <Tab icon={<img src={require("../../assets/images/About Us.png")} />} iconPosition='start' 
          label={ <div >
            <p className='tabSidebarLevel1'>About</p>
            <p className='tabssubheading'>Find out more about Beeline
            </p>
            </div>}{...a11yProps(0)} /> */}

{/* <Tab icon={<img src={require("../../assets/images/About Us.png")} />} iconPosition='start' label={ <div >
            <p className='tabSidebarLevel1'>Notifications</p>
            <p className='tabssubheading'>Customize your notifications
            </p>
            </div>} {...a11yProps(1)} /> */}